import React from "react";
import { IconProps } from "../icon";

export const Strikethrough_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 16a4 4 0 004 4h4a4 4 0 000-8m4-4a4 4 0 00-4-4h-4a4 4 0 00-4 4m-3 4h18"
    />
  </svg>
);
